module.exports = __webpack_public_path__ + "static/media/header-checkerboard-company.eb68eab7.svg";